import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Hero from './Hero/Hero';
import Jobs from './Jobs/Jobs';
import HeaderBgImage from './Hero/images/Header.jpg';
import FooterBgImage from './Hero/images/Footer.jpg';
import { groupBy } from './../../../utils/helpers';
import './CareersPositions.css';

class CareersPosition extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    getOrderByPositions() {
        const { jobs } = this.props;
        const orderElements = {};

        if (jobs) {
            const groupByPositions = groupBy(jobs, 'category');

            Object.keys(groupByPositions).sort().forEach((key) => {
                orderElements[key] = groupByPositions[key];
            });
        }

        return orderElements;
    }
    render() {
        const { isDesktop } = this.props;
        const items = this.getOrderByPositions();

        return (
            <section className="careers-position">
                <Helmet>
                    <title>Explore All the Open HPP Job Postings | HPP</title>
                    <meta name="description" property="og:description" content="Explore the current job openings at Hudson Pacific Properties." />
                </Helmet>
                <Hero
                    backgroundImage={HeaderBgImage}
                    orientation='left'
                    subTitle='Endless Opportunities'
                    title={(<h1>LEARN MORE ABOUT<br /> EXCITING WAYS TO WORK<br /> AT HUDSON PACIFIC</h1>)}
                    // buttonTitle='LIFE AT HUDSON PACIFIC'
                    // buttonLink='/careers'
                    // buttonType2='internal'
                    // buttonTitle2='GENERAL APPLICATION'
                    // buttonLink2='/apply'
                    triangleDown={true}
                />
                <Jobs items={items} isDesktop={isDesktop} />
                {/* <Hero
                    backgroundImage={FooterBgImage}
                    orientation='left'
                    subTitle='NOT SEEING YOUR ROLE?'
                    title={(<h1>YOU MAY ALSO APPLY<br />WITH OUR GENERAL<br />APPLICATION FORM</h1>)}
                    buttonTitle='HUDSON PACIFIC CAREERS'
                    buttonLink='/apply'
                    buttonType2='external'
                    buttonTitle2='Sunset Studios Careers'
                    buttonLink2='https://www.sunsetstudios.com/'
                    buttonTitle3='Quixote Careers'
                    buttonLink3='https://quixote.com/careers/'
                    triangleDown={false}
                /> */}
                <Link className="btn-link button button-full-width" to='/careers/recruitmentfraud'>
                    <span>A NOTICE ON RECRUITMENT SCAMS</span>
                </Link>
            </section>
        );
    }
}

CareersPosition.propTypes = {
    jobs: PropTypes.array,
    items: PropTypes.object,
    isDesktop: PropTypes.bool,
};

export default connect(
    ({ screen, content }) => ({
        isDesktop: screen.isDesktop,
        jobs: content.jobs,
    }),
    null,
)(CareersPosition);
